<template>
  <div class="mb-4">
    <label class="mb-1" v-if="name !== ''">
      {{ name }}: {{ description }}
    </label>

    <div
        class="d-flex align-center w-100"
    >
      <template>
        <v-img
            class="rounded"
            :alt="`${name} ${hasUrl ? 'image' : 'placeholder image'}`"
            :class="name === 'HorizontalLogo' ? 'bw-img-fit' : 'bw-img-fluid'"
            :src="computedSrc"
            max-width="200"
        />
      </template>

      <v-sheet
          v-if="hasUrl"
          color="white ms-2"
          rounded
          width="100%"
      >
        <div class="px-4">
          <small class="font-weight-bold">Alternate Text</small>
          <input type="text" class="form-control Media Alt Text" placeholder="Alt Text" :value="altText"
                 @change="$emit('alt-text', $event)"/>
        </div>

      </v-sheet>
    </div>

    <div class="mt-1">
      <v-btn
          v-if="!hasUrl"
          type="button"
          color="info"
          small
          @click="select"
      >
        <i class="fa fa-plus mr-2"></i>
        Select
        <template v-if="hasUrl">
          <template>
            <i class="fa fa-sync mr-2"></i>
            Change
          </template>
        </template>
      </v-btn>
      <v-btn
          v-if="hasUrl"
          color="primary"
          type="button"
          small
          @click="select"
      >
        <template>
          <i class="fa fa-sync mr-2"></i>
          Change
        </template>
      </v-btn>
      <v-btn
          v-if="hasUrl"
          type="button"
          @click="crop"
          small
          color="info"
      >
        <i class="fa fa-crop mr-2"></i>
        Crop
      </v-btn>
      <v-btn
          v-if="hasUrl"
          class="btn btn-danger btn-sm m-1"
          type="button"
          small
          @click="remove"
          color="error"
      >
        <template>
          <i class="fa fa-times mr-2"></i>
          Remove
        </template>
      </v-btn>
    </div>
    <v-divider></v-divider>

  </div>
</template>

<script>
export default {
  name: 'ImageManager',
  props: {
    altText: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      required: true,
      default() {
        return '';
      }
    },
    details: {
      default: false
    },
    size: {
      type: Array,
      required: true
    },
  },
  computed: {
    hasUrl() {
      return !!this.imageUrl;
    },
    computedSrc() {
      return this.hasUrl
          ? this.imageUrl
          : `https://via.placeholder.com/${this.size[0]}x${this.size[1]}`;
    },
  },
  methods: {
    select() {
      this.$emit('select', this.mediaData);
    },
    crop() {
      this.$emit('crop', this.mediaData);
    },
    remove() {
      this.$emit('remove', this.mediaData);
    }
  }
};
</script>

<style lang="scss">
.imageManager {
  &__imageContainer {
    max-width: 500px;
  }
}

.image-placeholder {
  width: 100%;
  height: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #6d6e71;
  border-radius: 4px;
  opacity: 1;
}

.bw-img-fluid {
  width: 100%;
  height: auto;
}

.bw-img-fit {
  max-width: 100%;
  max-height: 100%;
}
</style>
